import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RESET_ACTIVE_CANDIDATE, selectActiveCandidate, SET_ACTIVE_CANDIDATE, SET_DRAGGED_CANDIDATE } from '../stores/store.js'

export function Name({ name, active, onDragStart, onClick }) {
  const classList = [
    active ? "bg-gray-400" : "bg-gray-200"
  ]
  return <div className={"px-2 py-1 rounded cursor-pointer " + classList.join(" ")} draggable onDragStart={onDragStart} onClick={onClick}>
    { name }
  </div>
}

export function NameStateful({ name }) {
  const dispatch = useDispatch()

  const activeCandidate = useSelector(selectActiveCandidate)
  const active = activeCandidate === name

  const onDragStart = useCallback(() => {
    dispatch({ type: SET_ACTIVE_CANDIDATE, payload: name })
  }, [name])

  const onClick = useCallback(() => {
    if (!active) {
      dispatch({ type: SET_ACTIVE_CANDIDATE, payload: name })
    } else {
      dispatch({ type: RESET_ACTIVE_CANDIDATE })
    }
  }, [name, active])

  return <Name name={ name } active={active} onDragStart={onDragStart} onClick={onClick} />
}
